// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDfDmuwhMuP6hBGaMN68KrC6_eTjSPm6OQ",
    authDomain: "miclaropr-fdb27.firebaseapp.com",
    databaseURL: "https://miclaropr-fdb27.firebaseio.com",
    projectId: "miclaropr-fdb27",
    storageBucket: "miclaropr-fdb27.appspot.com",
    messagingSenderId: "715329712215",
    appId: "1:715329712215:web:b58392e5b5223b37383312",
    measurementId: "G-FH2N7WJPM7"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
